import { Divider, List, ListItem, ListItemText, TextField, Typography } from '@material-ui/core';
import { useBoolean } from '@lib/common';
import { Fragment, memo, useEffect } from 'react';
import { CompanyMasters } from '@api/masters';
import styled from 'styled-components';
import getLoadingMessage from '@lib/common/loading-messages';

export const ServiceDialogContent = memo<any>(
  ({ servicesLength, onSearch, serviceOptions, handleServiceClick }) => {
    const [showList, openList] = useBoolean(false);
    useEffect(() => {
      // Small optimization to open the dialog faster.
      setTimeout(openList, 100);
      // Clear results on unmount
      return () => onSearch({ target: { value: '' } });
    }, []);

    return (
      <>
        <TextField
          label="Search"
          placeholder={`Search across ${servicesLength} services`}
          variant="outlined"
          size="small"
          autoFocus
          helperText={
            serviceOptions.length === servicesLength
              ? 'Type to search...'
              : serviceOptions.length
              ? `Showing ${serviceOptions.length} results`
              : 'No results found!'
          }
          fullWidth
          onChange={onSearch}
        />
        <ListContainer>
          {!showList ? (
            <Typography color="textSecondary" className="loading" component="span">
              {getLoadingMessage()}
            </Typography>
          ) : (
            <List dense className="list">
              {serviceOptions.map((s: CompanyMasters.Service & { highlighted: string }) => (
                <Fragment key={`${s.id}-${s.highlighted}`}>
                  <ListItem button onClick={handleServiceClick && handleServiceClick(s)}>
                    <ListItemText>
                      {s.highlighted ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${s.highlighted} <small style='color:rgba(0,0,0,0.54)'>${
                              s.service_aka ? ' ( ' + s.service_aka + ') ' : ''
                            }</small>`,
                          }}
                        />
                      ) : (
                        <span>
                          {`${s.service}`}
                          <small style={{ color: 'rgba(0,0,0,0.54)' }}>{`${
                            s.service_aka ? ' ( ' + s.service_aka + ' ) ' : ''
                          }`}</small>
                        </span>
                      )}
                    </ListItemText>
                  </ListItem>
                  <Divider />
                </Fragment>
              ))}
            </List>
          )}
        </ListContainer>
      </>
    );
  }
);
const ListContainer = styled.div`
  height: 47vh;
  border: 1px solid #a1a1a1;
  overflow: auto;
  .list {
    padding: 0;
  }
  .loading {
    padding: 30px;
    display: block;
  }
`;
